import AppRoutes from "./app-routes";
import NotificationPrompt from "@common/components/notification/notification-prompt";
import React from "react";

const AppInitDependencies = () => {
    return (
        <>
            <AppRoutes/>
            <NotificationPrompt/>
        </>
    )
}

export default AppInitDependencies
